import SelectorEngine from '../../utils/dom/selector-engine';
import EventHandler from '../../utils/dom/event-handler';
import FormComponent from '../FormComponent';
import SearchInputField from '../SearchInputField';
import SchoolAddressSearch from '../SchoolAddressSearch';
import { InputTypes } from '../../utils/validateFormElement';
import { Events } from '../../utils/dom/html-events';
import { ClassNames } from '../../utils/dom/css-classes';
import AddressForm from './AddressForm';

class AddressFinder extends FormComponent {
    markup(value, rowData, titleMarkup) {
		return `
		<div class="lta-address-finder u-mb-5">
			<div class="lta-address-finder-title ${ClassNames.Hidden}">${titleMarkup}</div>
			<div class="lta-address-finder--search-input-wrapper">
				<div class="lta-address-finder--search-input u-mb-2"></div>
				<div class="lta-address-finder--search-form-button-wrapper u-flex">
					<button type="button" class="lta-address-finder--search-form-button lta-btn lta-btn--lg lta-btn--link">Can’t find your address? Enter manually</button>
				</div>
			</div>
			<div class="lta-address-finder--search-result ${ClassNames.Hidden}"></div>
			<div class="lta-address-finder--search-form ${ClassNames.Hidden}">
				<div class="lta-address-finder--search-form-wrapper"></div>
				<div class="lta-address-finder--search-form-button-wrapper u-flex">
					<button type="button" class="lta-address-finder--address-form-button lta-btn lta-btn--lg lta-btn--link">Use address look-up search</button>
				</div>
			</div>
		</div>
    `;
	}
	afterRender() {
        this.addressFinderElement = SelectorEngine.findOne('.lta-address-finder', this.containerEl);
		this.addressFinderTitle = SelectorEngine.findOne('.lta-address-finder-title', this.addressFinderElement);
		this.addressFinderSearchInputWrapper = SelectorEngine.findOne(
			'.lta-address-finder--search-input-wrapper',
			this.addressFinderElement
		);
		this.addressFinderSearchInput = SelectorEngine.findOne(
			'.lta-address-finder--search-input',
			this.addressFinderSearchInputWrapper
		);
		this.addressFinderSearchFormButton = SelectorEngine.findOne(
			'.lta-address-finder--search-form-button',
			this.addressFinderSearchInputWrapper
		);
		this.addressFinderSearchResult = SelectorEngine.findOne(
			'.lta-address-finder--search-result',
			this.addressFinderElement
		);
		this.addressFinderSearchForm = SelectorEngine.findOne('.lta-address-finder--search-form', this.addressFinderElement);
		this.addressFinderSearchFormWrapper = SelectorEngine.findOne(
			'.lta-address-finder--search-form-wrapper',
			this.addressFinderSearchForm
		);
		this.addressFinderAddressButton = SelectorEngine.findOne(
			'.lta-address-finder--address-form-button',
			this.addressFinderSearchForm
		);

		this.initSearchInputField();

		EventHandler.on(this.addressFinderSearchFormButton, Events.Click, () => {
			this.value = undefined;
			this.searchInputTextField.remove();
			this.addressFinderSearchInputWrapper.classList.add(ClassNames.Hidden);
			this.addressFinderSearchResult.classList.add(ClassNames.Hidden);
			this.addressFinderSearchForm.classList.remove(ClassNames.Hidden);
			this.addressFinderTitle.classList.remove(ClassNames.Hidden);

			this.addressFinderSearch = new AddressForm(this.addressFinderSearchFormWrapper, {
				data: this.data.addressFormElement
			});
			this.addressFinderSearch.onChange((value) => {
				this.setupValueObject(value, 'Partially Completed');
			});
		});

		EventHandler.on(this.addressFinderAddressButton, Events.Click, () => {
			this.value = undefined;
			this.addressFinderSearch.remove();
			this.initSearchInputField();
			this.addressFinderSearchInputWrapper.classList.remove(ClassNames.Hidden);
			this.addressFinderSearchResult.classList.add(ClassNames.Hidden);
			this.addressFinderSearchForm.classList.add(ClassNames.Hidden);
			this.addressFinderTitle.classList.add(ClassNames.Hidden);
		});
	}

	initSearchInputField() {
		this.searchInputTextField = new SearchInputField(this.addressFinderSearchInput, {
			data: {
				...this.data,
				additionalParams: this.data?.additionalSearchParam
			},
		});
		this.searchInputTextField.dataMapping = (item) => {
			return {
				firstLineText: item.schoolName,
				secondLineText: `${item.county}, ${item.postcode}`,
				dataKey: this.data.dataKey,
				dataValue: item.id
			};
		};
		this.searchInputTextField.filterDataMapping = (item, event) => {
			return item.id === event[this.data.dataKey];
		};
		this.searchInputTextField.searchInputMappingChange();
		this.searchInputTextField.onChange((event) => {
			this.loadSchoolResult(event.value, true);
		});
		this.setupValidateObject();
		if (this.data?.value) {
			this.loadSchoolResult(this.data?.value, false);
		}
	}
	loadSchoolResult(resultDetails, isSetupValueObject) {
		if (isSetupValueObject) {
			this.setupValueObject(resultDetails, 'Complete');
		}
		if (!resultDetails?.schoolName) {
			return;
		}
		this.addressFinderSearchInputWrapper.classList.add(ClassNames.Hidden);
		this.addressFinderSearchForm.classList.add(ClassNames.Hidden);
		this.addressFinderTitle.classList.remove(ClassNames.Hidden);
		this.addressFinderSearchResult.classList.remove(ClassNames.Hidden);
		this.addressFinderSearchResult.insertAdjacentHTML('beforeend', this.renderAutoSuggestResult(resultDetails));
		this.afterAutoSuggestResultRender();
	}
	setupValueObject(value, obBoardingStatus) {
		this.value = {
			...this.data,
			value: value
				? {
						...value,
						onboardingStatus: obBoardingStatus
				  }
				: undefined
		};
		if (this.value) {
			this.dependentQuestion = this.value.dependentQuestion;
		}
	}
	afterAutoSuggestResultRender() {
		const suggestionAutoSuggestResult = SelectorEngine.findOne(
			'.lta-autosuggest-input-result',
			this.addressFinderSearchResult
		);
		const searchAgainButton = SelectorEngine.findOne('.lta-address-search--again', suggestionAutoSuggestResult);

		EventHandler.on(searchAgainButton, Events.Click, () => {
			suggestionAutoSuggestResult.remove();
			this.addressFinderSearchInputWrapper.classList.remove(ClassNames.Hidden);
			this.addressFinderTitle.classList.add(ClassNames.Hidden);
			this.addressFinderSearchForm.classList.add(ClassNames.Hidden);
			this.addressFinderSearchResult.classList.add(ClassNames.Hidden);
		});
	}
	renderAutoSuggestResult(schoolDetail) {
		return `<div class="lta-autosuggest-input-result">
					<p class="lta-text-input__label">Your school</p>
					<div class="u-px-3 u-py-2 u-bg-background-blue u-rounded">
						<div class="lta-autosuggest-input-result_school-name u-h6 u-mb-1">${schoolDetail.schoolName}</div>
						<div class="u-body2 u-mb-2">
							${schoolDetail.address.street} ${schoolDetail.address.city} ${schoolDetail.address.state}
							<br>${schoolDetail.county}
							<br>${schoolDetail.postcode}
						</div>
						<button type="button" class="lta-btn lta-btn--xs lta-btn--petite lta-btn--icon lta-btn--icon-before lta-address-search--again">
							<svg class="lta-icon js-lta-text-input--btn-icon u-mr-0" width="1.5em" height="1.5em" fill="currentColor" alt="search" aria-hidden="true">
								<use xlink:href="/static/images/icons/lta-icons.svg#search"></use>
							</svg>Search again
						</button>
					<div>
				</div>`;
	}
	renderInstructionLabel(instructionLabel) {
		return instructionLabel ? `<span class="lta-text-input__label-instruction">${instructionLabel}</span>` : '';
	}
	setupValidateObject() {
		this.formElementData = {
			element: this.searchInputFieldContainerElement,
			formElement: this.searchInputFieldElement,
			errorMessage: this.data.errorMessage,
			inputType: InputTypes.SELECTOR_INPUT,
			hasIcon: false
		};
	}
	validate() {
        this.searchInputTextField.validate();
		if (this.addressFinderSearch) {
			this.addressFinderSearch.validate();
		}
	}
}
export default AddressFinder;
